import { render, staticRenderFns } from "./actions-history-button.vue?vue&type=template&id=ae31c712&scoped=true&lang=pug&"
import script from "./actions-history-button.vue?vue&type=script&lang=ts&"
export * from "./actions-history-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae31c712",
  null
  
)

export default component.exports